/** Display labels only. API codes, catalogue symbols and stored field names stay unchanged. */
export const EMISSION_UNIT_LABELS = {
  kgCO2e: "kg CO₂e",
  tCO2e: "t CO₂e",
} as const;

export function formatEmissionUnit(value?: string | null): string {
  if (!value) return "";
  return value
    .replace(
      /\b(kg|g|t|kt|Mt)\s*CO[2₂](?:eq|e)\b/gi,
      (_match, mass: string) => {
        // Preserve ambiguous prefixes and mega-tonnes (Mt); this never converts values.
        const lower = mass.toLowerCase();
        const prefix = ["kg", "g", "t", "kt"].includes(lower) ? lower : mass;
        return `${prefix} CO₂e`;
      },
    )
    .replace(/\bCO[2₂](?:eq|e)\b/gi, "CO₂e");
}
